import axios from "axios";
import { captureException } from "@sentry/nextjs";
const publicKey = process.env.NEXT_PUBLIC_UPLOADCARE_PUBLIC_KEY
const secretKey = process.env.UPLOADCARE_SECRET_KEY


const deleteImage = async (uuid) => {
   try {
    const url = `https://api.uploadcare.com/files/${uuid}/`
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Uploadcare.Simple ${publicKey}:7be954797e6263225075`
    }
    const response = await axios.delete(url, { headers })
    return response.data
   } catch (error) {
    throw new Error(error)
   }
}


export { deleteImage }